export default __webpack_public_path__ + "static/media/news-bg-two.b4438d4d.jpg";